<template>
  <header class="grid grid-cols-12 text-white">
    <!-- slot used for video, implemented on Home.vue template -->
    <slot />

    <!-- logo, titles and cta -->
    <section class="row-start-1 col-span-full container z-grid v-page-section-container-padding pt-10 lg:pt-16 xl:pt-20">
      <div class="c-home-header-content col-span-full row-start-1 mx-auto sm:mx-8 md:mx-10 lg:mx-16 xl:mx-0 2xl:mx-32">
        <h1 class="pointer-events-none">
          <span id="main-title" class="leading-6 text-6xl font-normal text-white v-clip" aria-hidden="true">{{ title }}</span>
          <AtomBrandConcertgebouwLogo class="text-white h-20 xl:h-32" />
        </h1>
        <hr class="c-home-header-divider my-6 lg:mt-8" />
        <h2 v-if="subtitle" class="c-home-header-subtitle font-medium leading-tight text-lg lg:text-2xl xl:text-3xl mb-4 lg:mb-6" aria-hidden="true">
          {{ subtitle }}
        </h2>
        <ul v-if="buttons.length" class="w-full lg:pr-12 lg:mt-24">
          <li v-for="(button, index) in buttons" :key="index" class="w-full" :class="{ 'mb-4': index < buttons.length - 1 }">
            <MoleculeButton :url="button.url" size="large" class="lg:hidden w-full" background-color="bg-app-primary-1-red--fire-brick hover:bg-black">
              {{ button.title }}
            </MoleculeButton>
            <MoleculeButton :url="button.url" size="x-large" class="hidden lg:flex w-full" background-color="bg-app-primary-1-red--fire-brick hover:bg-black">
              {{ button.title }}
            </MoleculeButton>
          </li>
        </ul>
      </div>
    </section>

    <!-- sponsors -->
    <section v-if="sponsors.length" class="hidden row-start-1 col-span-full sm:flex flex-col items-end pt-10 pr-8 md:pr-12 lg:pt-12 xl:pr-20">
      <div class="w-32 xl:w-40">
        <h3 class="text-sm xl:text-base leading-tight mb-3" aria-hidden="true">{{ $t('home-header-sponsor-title') }}</h3>
        <ul class="w-full">
          <li v-for="(sponsor, index) in sponsors" :key="index" class="w-full mb-4">
            <AtomLink :url="sponsor.url">
              <MoleculePicture
                :image="sponsor.image"
                :alt="sponsor.title ? sponsor.title : sponsor.image ? sponsor.image.title : undefined"
                :lazy="false"
                class="block w-full"
              ></MoleculePicture>
            </AtomLink>
          </li>
        </ul>
      </div>
    </section>
  </header>
</template>

<script setup lang="ts">
defineProps({
  title: { type: String, required: true },
  subtitle: { type: String, required: false, default: undefined },
  buttons: { type: Array as PropType<any[]>, required: false, default: () => [] },
  sponsors: { type: Array as PropType<any[]>, required: false, default: () => [] },
})
</script>

<style lang="scss" scoped>
.c-home-header-content {
  width: 100%;

  @screen sm {
    width: 272px;
  }

  @screen lg {
    width: 360px;
  }

  @screen xl {
    width: 440px;
  }
}

.c-home-header-divider {
  @apply border-t-2 border-white border-solid;

  @screen lg {
    border-top-width: 3px; // not a value in TailwindCSS
  }
}
</style>
